import React from 'react'

import { Divider } from 'primereact/divider'

import { useTenantById } from '../../../data/tenants'
import { useCurrentTenantId } from '../../../utils/tenants'

type Props = {
  children?: React.ReactNode
}

const TenantInfo: React.FC<Props> = ({ children }: Props) => {
  const tenantId = useCurrentTenantId()
  const { data, isLoading, error } = useTenantById(tenantId as string)

  if (isLoading)
    return (
      <>
        <Divider />
        <div>Loading ...</div>
      </>
    )
  if (error) return null

  return (
    <>
      <Divider />
      <div className="flex">
        <div className="mr-2">
          <span className="font-bold">{data?.name}</span>
          <br />
          <small className="">{data?.id}</small>
        </div>
        <div className="mr-2">{children}</div>
      </div>
    </>
  )
}

export default TenantInfo
